var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "DeviceRealtimeStatus",
      attrs: { "data-status": _vm.status },
    },
    [_c("span", { attrs: { "data-part": "icon" } }, [_vm._t("default")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }